{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "Selamat pagi",
        "afternoon": "Selamat siang",
        "evening": "Selamat malam"
      },
      "header": {
        "fallbackUser": "Pengguna",
        "facility": "Fasilitas {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} hasil kritis memerlukan konfirmasi",
        "message_other": "{{count}} hasil kritis memerlukan konfirmasi",
        "reviewNow": "Tinjau sekarang"
      },
      "sections": {
        "overview": "Ringkasan",
        "tasks": "Tugas",
        "myPatients": "Pasien Saya",
        "recentActivity": "Aktivitas Terbaru",
        "quickActions": "Tindakan Cepat"
      },
      "stats": {
        "activeEncounters": "Kunjungan Aktif",
        "pendingOrders": "Order Tertunda",
        "resultsToReview": "Hasil yang Perlu Ditinjau",
        "criticalAlerts": "Peringatan Kritis"
      },
      "tasks": {
        "unsignedNotes": "Catatan Belum Ditandatangani",
        "criticalResultsPending": "Hasil Kritis Tertunda",
        "cosignaturesNeeded": "Perlu Tanda Tangan Bersama",
        "ordersToReview": "Order untuk Ditinjau",
        "activeMedications": "Obat Aktif",
        "admissionsPending": "Penerimaan Tertunda",
        "ordersToVerify": "Order untuk Verifikasi Apoteker",
        "controlledSubstanceReviews": "Tinjauan Obat Terkontrol",
        "systemAlerts": "Peringatan Sistem",
        "systemStatus": "Status Sistem"
      },
      "systemStatusValue": {
        "healthy": "Sehat"
      },
      "empty": {
        "noPatients": "Belum ada pasien aktif yang ditugaskan.",
        "noTasks": "Tidak ada tugas khusus untuk peran ini.",
        "noRecentEncounters": "Tidak ada kunjungan terbaru."
      },
      "quickActions": {
        "findPatient": {
          "label": "Cari Pasien",
          "description": "Cari rekam medis"
        },
        "registerPatient": {
          "label": "Daftarkan Pasien",
          "description": "Tambah pasien baru"
        },
        "viewCensus": {
          "label": "Lihat Sensus",
          "description": "Kunjungan aktif"
        },
        "reports": {
          "label": "Laporan",
          "description": "Lihat analitik"
        }
      },
      "viewAll": "Lihat Semua",
      "bedLabel": "Tempat tidur {{n}}",
      "admittedLabel": "Diterima {{date}}",
      "fallback": {
        "unknownPatient": "Pasien Tidak Diketahui",
        "unknownType": "Tidak Diketahui"
      },
      "acuity": {
        "1": "Resusitasi",
        "2": "Darurat",
        "3": "Mendesak",
        "4": "Kurang Mendesak",
        "5": "Tidak Mendesak"
      },
      "encounterType": {
        "emergency": "Gawat Darurat",
        "inpatient": "Rawat Inap",
        "outpatient": "Rawat Jalan",
        "observation": "Observasi"
      },
      "encounterStatus": {
        "active": "Aktif",
        "completed": "Selesai",
        "discharged": "Dipulangkan",
        "cancelled": "Dibatalkan",
        "pending": "Tertunda"
      }
    },
    "qualityMeasures": {
      "title": "Indikator Mutu",
      "subtitle": "Pantau indikator mutu klinis dan kepatuhan regulasi",
      "refresh": "Muat Ulang",
      "allTypesLabel": "Semua Jenis",
      "allFacilitiesLabel": "Semua Fasilitas",
      "targetPrefix": "Target: {{value}} {{unit}}",
      "updatedPrefix": "Diperbarui: {{value}}",
      "measureType": {
        "process": "Proses",
        "outcome": "Hasil",
        "structure": "Struktural"
      },
      "summary": {
        "totalMeasures": "Total Indikator",
        "meetingTarget": "Memenuhi Target",
        "belowTarget": "Di Bawah Target"
      },
      "toasts": {
        "refreshSuccess": "Indikator dimuat ulang"
      },
      "results": {
        "title": "Hasil yang dicatat",
        "period": "Periode",
        "facility": "Fasilitas",
        "denominator": "Penyebut",
        "numerator": "Pembilang",
        "exclusions": "Pengecualian",
        "rate": "Tingkat",
        "source": "Sumber",
        "calculated": "Dihitung",
        "empty": "Tidak ada hasil yang dicatat untuk ukuran ini pada periode ini.",
        "loadError": "Gagal memuat hasil yang dicatat.",
        "allFacilities": "Semua Fasilitas",
        "record": "Catat hasil"
      },
      "sources": {
        "manual": "Manual",
        "sql-template": "Templat SQL",
        "import": "Impor"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "Laporan QRDA diunduh",
        "error": "Unduhan QRDA gagal"
      },
      "record": {
        "title": "Catat hasil mutu",
        "titleFor": "Catat hasil — {{code}} {{name}}",
        "subtitle": "Hasil yang dicatat muncul di riwayat ukuran dan masuk ke ekspor QRDA Kategori III. Mencatat ulang suatu periode akan menggantikan baris sebelumnya.",
        "back": "Kembali ke ukuran mutu",
        "cancel": "Batal",
        "save": "Catat hasil",
        "measureNotFound": "Ukuran tidak ditemukan. Mungkin sudah dinonaktifkan.",
        "fields": {
          "periodStart": "Awal periode",
          "periodEnd": "Akhir periode",
          "facility": "Fasilitas",
          "allFacilities": "Semua Fasilitas",
          "denominator": "Penyebut",
          "numerator": "Pembilang",
          "exclusions": "Pengecualian",
          "source": "Sumber perhitungan",
          "completeness": "Kelengkapan data",
          "completenessHint": "Fraksi rekam layak dengan data lengkap, 0 sampai 1. Kosongkan jika tidak diketahui.",
          "notes": "Catatan"
        },
        "errors": {
          "periodStartRequired": "Awal periode wajib diisi",
          "periodEndRequired": "Akhir periode wajib diisi",
          "periodOrder": "Akhir periode harus pada atau setelah awal periode",
          "countInvalid": "Masukkan bilangan bulat, 0 atau lebih",
          "numeratorExceeds": "Pembilang tidak boleh melebihi penyebut",
          "numeratorExceedsNet": "Pembilang tidak boleh melebihi penyebut dikurangi pengecualian",
          "sourceRequired": "Sumber perhitungan wajib diisi",
          "completenessRange": "Kelengkapan harus antara 0 dan 1"
        },
        "toast": {
          "success": "Hasil tercatat",
          "error": "Pencatatan gagal"
        }
      }
    },
    "analyticsDashboard": {
      "title": "Dasbor Analitik",
      "subtitle": "Metrik dan tren kinerja rumah sakit",
      "refresh": "Muat Ulang",
      "changeVsPrevPeriod": "{{sign}}{{value}}% vs periode sebelumnya",
      "dateRange": {
        "today": "Hari Ini",
        "7d": "7 Hari",
        "30d": "30 Hari",
        "90d": "90 Hari"
      },
      "facility": {
        "all": "Semua Fasilitas",
        "sgh": "SGH - Singapore General Hospital",
        "nuh": "NUH - National University Hospital",
        "ttsh": "TTSH - Tan Tock Seng Hospital"
      },
      "department": {
        "all": "Semua Departemen",
        "er": "Gawat Darurat",
        "icu": "ICU",
        "medsurg": "Penyakit Dalam/Bedah",
        "peds": "Anak",
        "maternity": "Maternitas"
      },
      "widget": {
        "census": {
          "title": "Sensus Saat Ini"
        },
        "bedOccupancy": {
          "title": "Okupansi Tempat Tidur"
        },
        "avgLOS": {
          "title": "Rata-rata Lama Rawat"
        },
        "throughput": {
          "title": "Total Kunjungan"
        },
        "readmission": {
          "title": "Pesanan Menunggu"
        }
      },
      "unit": {
        "patients": "pasien",
        "days": "hari",
        "encounters": "kunjungan",
        "orders": "pesanan"
      },
      "charts": {
        "admissionsVsDischarges": "Admisi vs Pemulangan",
        "admissionsByDepartment": "Admisi per Departemen",
        "encounterTypes": "Tipe Kunjungan",
        "censusTrend": "Tren Sensus",
        "insufficientData": "Data tidak cukup untuk grafik",
        "insufficientTrendData": "Data tidak cukup untuk grafik tren"
      },
      "series": {
        "admissions": "Admisi",
        "discharges": "Pemulangan",
        "census": "Sensus"
      },
      "toasts": {
        "refreshSuccess": "Dasbor dimuat ulang"
      }
    },
    "reportRunner": {
      "title": "Pelaksana Laporan",
      "subtitle": "Buat dan ekspor laporan klinis, keuangan, dan operasional",
      "scheduleButton": "Jadwalkan Laporan",
      "searchPlaceholder": "Cari laporan...",
      "allCategoriesLabel": "Semua Laporan",
      "category": {
        "clinical": "Klinis",
        "financial": "Keuangan",
        "operational": "Operasional",
        "quality": "Kualitas"
      },
      "emptyState": {
        "title": "Pilih laporan untuk memulai",
        "subtitle": "Pilih dari daftar laporan di sebelah kiri"
      },
      "noResults": "Tidak ada laporan yang cocok dengan filter Anda",
      "parametersHeading": "Parameter",
      "selectOptionPlaceholder": "Pilih...",
      "runButton": "Jalankan Laporan",
      "runningReport": "Menjalankan laporan...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "Tanggal (waktu lokal fasilitas)",
        "facilityTimeZone": "Zona waktu fasilitas",
        "encounterDate": "Tanggal (UTC)"
      },
      "resultSummary": {
        "rows": "Menampilkan {{shown}} dari {{total}} baris",
        "executed": "Dieksekusi dalam {{ms}}ms"
      },
      "toasts": {
        "success": "Laporan selesai dalam {{executionTimeMs}}ms - {{rowCount}} baris",
        "failed": "Gagal menjalankan laporan",
        "missingFields": "Harap isi kolom yang wajib diisi: {{missingFields}}",
        "exporting": "Mengekspor sebagai {{format}}... (placeholder)",
        "scheduledPlaceholder": "Pengaturan laporan terjadwal (placeholder)"
      }
    }
  }
}
